export default __webpack_public_path__ + "static/media/song.29370fb6.svg";